import { Component } from '@angular/core';
import { NgpPaginationButton } from 'ng-primitives/pagination';

@Component({
  selector: 'button[joii-pagination-dot]',
  hostDirectives: [
    {
      directive: NgpPaginationButton,
      inputs: ['ngpPaginationButtonPage:page'],
    },
  ],
  imports: [],
  template: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6" fill="none">
    <circle cx="3" cy="3" r="3" />
  </svg>`,
  styles: `
    :host {
      --joii-pagination-dot-size: 6px;
    }
    :host svg {
      width: var(--joii-pagination-dot-size);
      height: var(--joii-pagination-dot-size);
    }
    :host svg circle {
      fill: var(--Vetai-Form_controls--Border_Default);
    }
    :host[data-selected] svg circle {
      fill: var(--Vetai-Inline_links_and_info--Default);
    }
  `,
})
export class PaginationDotComponent {}
